require('./show.jade')
require('angular')
require('angular-route')
require('angular-sanitize')
require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')

# Load Css
require('../../../sass/web/html/_term.scss')

TermShowCtrl = require('./show-controller')
TermService = require('../components/term/term-module')

modules = [
  'ngRoute'
  'ngSanitize'
  'gnp-translation'
  'gnp-term'
  'gnp-common-wrapper'
  'gnp-error-handler'
]
angular.module "gnp-app-term", modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/term',
      templateUrl: 'web/term/show.jade'
      controller: 'TermShowCtrl'
      resolve:
        term: ['TermService', (TermService) ->
          TermService.get()
        ]
      title: '_TERM.TITLE'
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'TermShowCtrl', TermShowCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/term/term-module.coffee